export interface BookingSlotBooking {
  id: string;
  court_id: string;
  start_time: string;
  end_time: string;
  status: string;
}

export type BookingSlotInfo<T extends BookingSlotBooking = BookingSlotBooking> =
  | { type: "free" }
  | { type: "booking_start"; booking: T; slotCount: number; /** PR-AJ Layer D: extra overlapping bookings at this slot (conflict count > 0). */ conflictBookings: T[] }
  | { type: "booking_mid"; booking: T; conflictBookings: T[] };

export function getBookingSlotInfo<T extends BookingSlotBooking>(
  courtId: string,
  slot: Date,
  bookings: T[]
): BookingSlotInfo<T> {
  // PR-AJ Layer D: collect ALL non-cancelled bookings that cover this slot.
  // Render conflict indicator when multiple bookings overlap.
  const matching = bookings.filter(
    (b) =>
      b.court_id === courtId &&
      b.status !== "cancelled" &&
      slot >= new Date(b.start_time) &&
      slot < new Date(b.end_time)
  );
  if (matching.length === 0) return { type: "free" };

  const booking = matching[0];
  // Conflict bookings = all others overlapping this slot (used by render layer
  // to show a visible "1+ conflict" badge so admin notices the data overlap).
  const conflictBookings = matching.slice(1);

  const bStart = new Date(booking.start_time);
  const isFirst = slot.getTime() === bStart.getTime();
  const bEnd = new Date(booking.end_time);
  const slotCount = (bEnd.getTime() - bStart.getTime()) / (30 * 60_000);

  return isFirst
    ? { type: "booking_start", booking, slotCount, conflictBookings }
    : { type: "booking_mid", booking, conflictBookings };
}
